<template>
  <div v-if="isLoading" class="loading-mask">
    <div class="loader"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("app", ["isLoading"]),
  },
};
</script>

<style scoped lang="scss">
@use "@/assets/styles/index.scss" as *;

.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

/* loader 样式 */
/* HTML: <div class="loader"></div> */
.loader {
  width: fit-content;
  font-size: 40px;
  // font-family: "Noto Sans SC";
  font-weight: 900;
  text-transform: uppercase;
  color: rgba($color: $primary-color, $alpha: .3);
  // -webkit-text-stroke: 1px $primary-color;
  background:
    radial-gradient(0.71em at 50% 1em,$primary-color 99%,#0000 101%) calc(50% - 1em) 1em/2em 200% repeat-x text,
    radial-gradient(0.71em at 50% -0.5em,$primary-color 99%,$primary-color 101%) 50% 1.5em/2em 200% repeat-x text;
  animation: 
    l10-0 .8s linear infinite alternate,
    l10-1  4s linear infinite;
}
.loader:before {
  content: "中能E签";
}
@keyframes l10-0 {
  to {background-position-x: 50%,calc(50% + 1em)}
}
@keyframes l10-1 {
  to {background-position-y: -.5em,0}
}
</style>
